import React from 'react';
import { FiCheckCircle, FiPhone, FiXCircle } from 'react-icons/fi'

const Notifications = () => {
  return (
    <React.Fragment>
       {/** NOTIFICATION **/}
      <div className="my-3">
        <div className="flex items-center justify-between mx-3 mb-5">
          <div className="flex items-center gap-2">
            <div
              className="text-sm bg-red-500 rounded-full w-5 h-5 text-white font-medium flex items-center justify-center"
            >
              5
            </div>
            <div className="font-semibold">Notifications</div>
          </div>
          <div className="flex">
            <div
              className="border-b-2 border-gray-200 dark:border-gray-500 text-sm text-gray-500 dark:text-gray-300 cursor-pointer p-1 px-3"
            >
              Unread
            </div>
            <div
              className="border-b-2 border-blue-500 text-sm text-gray-500 dark:text-gray-300 cursor-pointer p-1 px-3"
            >
              All
            </div>
          </div>
        </div>
        <ul className="m-3">
          <li>
            <div className="flex gap-2 items-center mb-2">
              <img
                src="/images/avatars/Vector-3.png"
                className="rounded-full w-12 h-12 cursor-pointer"
              />
              <div>
                <div className="flex gap-2 items-center">
                  <div
                    className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                  >
                    Jane Doe
                  </div>
                  <div className="text-gray-500 dark:text-gray-400 text-sm">
                    Sent message
                  </div>
                </div>
                <div className="text-gray-400 text-sm font-medium">
                  10 hours ago
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="flex gap-2 items-center mb-2">
              <img
                src="/images/avatars/Vector-4.png"
                className="rounded-full w-12 h-12 cursor-pointer"
              />
              <div>
                <div className="flex gap-2 items-center">
                  <div className="text-gray-500 dark:text-gray-400 text-sm">
                    Missed call from
                  </div>
                  <div
                    className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                  >
                    Jasmine
                  </div>
                </div>
                <div className="text-gray-400 text-sm font-medium">
                  1 days ago
                </div>
                <div
                  className="bg-gray-200 dark:bg-gray-600 cursor-pointer p-1 px-3 my-2 rounded-md w-max flex items-center justify-center text-gray-500 dark:text-gray-300"
                >
                  <FiPhone
                    className="text-gray-500 dark:text-gray-300 h-4"
                  /> 
                  <p>Call Back</p>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="flex gap-2 items-center mb-2">
              <img
                src="/images/avatars/Vector-5.png"
                className="rounded-full w-12 h-12 cursor-pointer"
              />
              <div>
                <div className="flex gap-2 items-center">
                  <div
                    className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                  >
                    Jessica
                  </div>
                  <div className="text-gray-500 dark:text-gray-400 text-sm">
                    Added you
                  </div>
                </div>
                <div className="text-gray-400 text-sm font-medium">
                  2 days ago
                </div>
                <div className="flex gap-2">
                  <div
                    className="bg-blue-500 cursor-pointer p-2 px-3 my-2 rounded-md w-max flex items-center justify-center text-white text-sm"
                  >
                    <FiCheckCircle
                      className="text-gray-500 h-4 text-white"
                    />
                    <p>Accept</p>
                  </div>
                  <div
                    className="bg-gray-200 dark:bg-gray-600 cursor-pointer p-2 px-3 my-2 rounded-md w-max flex items-center justify-center text-gray-500 dark:text-gray-300 text-sm"
                  >
                    <FiXCircle
                      className="text-gray-500 dark:text-gray-300 h-4"
                    />
                    <p>Reject</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="flex gap-2 items-center mb-2">
              <img
                src="/images/avatars/Vector-7.png"
                className="rounded-full w-12 h-12 cursor-pointer"
              />
              <div>
                <div className="flex gap-2 items-center">
                  <div
                    className="text-gray-700 dark:text-gray-300 font-semibold cursor-pointer"
                  >
                    Jamie
                  </div>
                  <div className="text-gray-500 dark:text-gray-400 text-sm">
                    Sent message
                  </div>
                </div>
                <div className="text-gray-400 text-sm font-medium">
                  1 weeks ago
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </React.Fragment>
  )
}

export default Notifications
